// Vocabulary for the slack_deliveries receipt table. The channel classes are
// authored canonically in `@galapagos/events` (SLACK_CHANNEL_CLASSES on the
// route registry); this package cannot import that workspace, so the CHECK
// constraint carries its own copy and the notifier-side drift test in
// apps/api (which imports both packages) pins the two lists equal.

import { z } from 'zod';

export const SLACK_DELIVERY_CHANNEL_CLASS = [
  'ops',
  'escalation',
  'care_ops',
  'rx_support',
  'onboarding',
  'eligibility_ops',
] as const;
export const slackDeliveryChannelClassSchema = z.enum(SLACK_DELIVERY_CHANNEL_CLASS);
export type SlackDeliveryChannelClass = z.infer<typeof slackDeliveryChannelClassSchema>;

/**
 * `root` is the one top-level card per dedupe key (the partial unique index
 * arbitrates concurrent claims); `reply` rows are threaded follow-ups on the
 * root's message_ts.
 */
export const SLACK_DELIVERY_KIND = ['root', 'reply'] as const;
export const slackDeliveryKindSchema = z.enum(SLACK_DELIVERY_KIND);
export type SlackDeliveryKind = z.infer<typeof slackDeliveryKindSchema>;
